import { Component, inject } from '@angular/core';
import { MenuController } from '@ionic/angular';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { CoreRouterActionNavigateToPageModule } from '../../core-router.actions';
import { CoreActionLogout } from '../../core.actions';
import { CorePageModule, CoreUser } from '../../core.models';
import {
  selectorCoreAppVersion,
  selectorCoreEntryPageModulesIDs,
  selectorCorePageModules,
  selectorCoreUser
} from '../../core.reducer';

@Component({
  selector: 'app-root',
  templateUrl: './app-static-menu.component.html',
  styleUrls: ['./app-static-menu.component.scss'],
  standalone: false
})
export class CoreAppStaticMenuComponent {
  menu = inject(MenuController);
  private store = inject<Store<any>>(Store);

  user$: Observable<CoreUser>;
  appVersion$: Observable<string>;
  entryPageModules$: Observable<CorePageModule[]>;

  constructor() {
    this.user$ = this.store.pipe(select(selectorCoreUser));
    this.appVersion$ = this.store.pipe(
      select(selectorCoreAppVersion),
      map(version => version || 'x.x.x')
    );
    this.entryPageModules$ = this.store.pipe(
      select(selectorCoreEntryPageModulesIDs),
      switchMap(modulesIDs =>
        this.store.pipe(
          select(selectorCorePageModules),
          map(modules =>
            modules.filter(module => modulesIDs.indexOf(module.ID) > -1)
          )
        )
      )
    );
  }

  logout(): void {
    this.store.dispatch(new CoreActionLogout());
  }

  navigateToModule(module: CorePageModule): void {
    this.store.dispatch(
      new CoreRouterActionNavigateToPageModule({ id: module.ID })
    );
  }
}
